import api from './api'

export const therapyReviewService = {
  fetchList(params = {}) {
    const query = new URLSearchParams()
    if (params.therapyId) query.append('therapyId', params.therapyId)
    if (params.therapistId) query.append('therapistId', params.therapistId)
    if (params.rating) query.append('rating', params.rating)
    query.append('page', params.page ?? 0)
    query.append('size', params.size ?? 10)
    return api.get(`/therapy/reviews?${query.toString()}`)
  },
  setVisibility(id, visible) {
    return api.patch(`/therapy/reviews/${id}/visibility`, null, { params: { visible } })
  },
  reply(id, content) {
    return api.post(`/therapy/reviews/${id}/reply`, null, { params: { content } })
  },
  activitySummary(id) {
    return api.get(`/therapy/reviews/summary/activity/${id}`)
  },
  therapistSummary(id) {
    return api.get(`/therapy/reviews/summary/therapist/${id}`)
  }
}
